var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tpfooter"}},[_c('div',{staticClass:"tp-bg"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$store.state.store.footer)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }